<template>
	<div>
		<a-modal v-show='!ishand' id='warp_sim1' width='40rem' v-model="visible" on-ok="handleOk1" v-dragModal
			:dialog-style="{ top: '20vh' }" @cancel="handleCancel(0)"
			:footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div v-if="form.state == 1" class="tableBzViewTitle2" style="width: 38rem;">審核拒絕</div>
				<div v-if="form.state == 2" class="tableBzViewTitle2" style="width: 38rem;">取消開戶</div>
				<div v-if="form.state == 0" v-html='"備&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;註"' style="width: 38rem;">
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="width: 38rem;" class='body_lis'>
				<div style="padding-top: 1.5rem;position: relative;left: -.5rem;">
					<div v-if="record.aduit" class="tableBzViewTextarea" style="position:relative;">
						<viewfroms v-if='viewfromFn(record)' ref='viewfroms' @child='handclose()' :record='record'>
						</viewfroms>
						<!-- <a-textarea :maxLength=200 :autoSize="{minRows: 4, maxRows: 10}" style="padding-bottom:2rem;" v-model="this.form.remark" placeholder="請輸入備註信息"/>
					    <span style="color:#bfbfbf;position:absolute;bottom:10px;right:10px;">{{this.form.remark.length}}/200</span> -->
					</div>
					<a-row v-if='tableData.length'>
						<div class='mydivs' :style="{maxHeight: aduit?'11rem':'18rem'}">
							<div v-for='(item,ind) in tableData'>
								<div class="c">
									<div>
									<div  style="display: inline-block;width: 8rem;vertical-align: top;">
										<span style='font-weight: 700;'>{{item.admin}}</span>　
									</div>
									<div style="display: inline-block;" v-if='item.remark'> :　{{ item.remark }}</div>
									</div>
										<!--  style="color: #3bc7a1;"  style='color: #ed4853;'-->
										<!-- <span v-if='item.status == 0'>審核通過</span>
										<span v-else-if='item.status == 1'>審核拒絕</span>
										<span v-else-if='item.status == 2'>取消開戶</span> -->
									<!-- </div> -->
									<div>
										{{ item.auditDate }}
									</div>
									
									</div>
									<div class='t' v-if='ind !== tableData.length-1'></div>
								</div>
								<!-- <div class="c" v-if='item.remark'>{{ item.remark }}</div> -->
								<!-- <div class='t' v-if='ind !== tableData.length-1'></div> -->
							</div>
					</a-row>
					<a-form-model ref='form' :model="form" labelAlign='right' layout="inline" :rules='rules'
						hideRequiredMark v-if='aduit'>
						<div id='lastname'>
							<a-form-model-item prop='remark'>
								<div slot='label' v-html='"備註信息"'
									style="display: inline-block;color: #000000;"></div>
								<a-textarea v-model="form.remark" placeholder="請輸入備註信息"
									:auto-size="{ minRows: 5, maxRows: 5 }" />
							</a-form-model-item>
						</div>
					</a-form-model>
					<div v-if="record.aduit && ifQt" :class="record.shKhadmin1Bol?'tablecenter':'tableBzViewBtnView'">
					    <a-popconfirm v-if="!record.shKhadmin1Bol" title="拒絕審批通過？" @visibleChange="visibleShow(record,'1')" v-model="popconfirm2Bol" 
					        ok-text="確定" cancel-text="取消"  @confirm="shUnTgEvent(record,'1')" :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
					        <a-icon slot="icon" type="question-circle-o" style="display: none;" />
							<a-button class="tableBzViewBtn" style="background-color:#ed4849;">審核拒絕</a-button>
					    </a-popconfirm>
						<a-popconfirm title="確認審批通過？" @visibleChange="visibleShow(record,'0')" v-model="popconfirm1Bol"
						     ok-text="確定" cancel-text="取消"  @confirm="shTgEvent(record,'0')" :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
													    <a-icon slot="icon" type="question-circle-o" style="display: none;" />
						     <a-button class="tableBzViewBtn" style="background-color: rgb(12, 139, 151);">{{record.shKhadmin1Bol ? '已處理' :'審核通過'}}</a-button>
						 </a-popconfirm>
					    <a-popconfirm v-if="!record.shKhadmin1Bol" title="確認取消開戶？" @visibleChange="visibleShow(record,'2')" v-model="popconfirm3Bol" 
					        ok-text="確定" cancel-text="取消"  @confirm="shTgEvent(record,'2')" :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
					        <a-icon slot="icon" type="question-circle-o" style="display: none;" />
							<a-button  class="tableBzViewBtn" style="background-color:#ffa647;">取消開戶</a-button>
					    </a-popconfirm>                                                
					</div>
					<div v-if="record.aduit && !ifQt" :class="record.shKhadmin1Bol?'tablecenter':'tableBzViewBtnView'">
					    <a-popconfirm v-if="!record.shKhadmin1Bol" title="拒絕審批通過？" @visibleChange="visibleShow(record,'1')" v-model="popconfirm2Bol" 
					        ok-text="確定" cancel-text="取消"  @confirm="shUnTgEvent(record,'1')" :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
					        <a-icon slot="icon" type="question-circle-o" style="display: none;" />
							<a-button class="tableBzViewBtn" style="background-color:#ed4849;">審核拒絕</a-button>
					    </a-popconfirm>
						<a-popconfirm title="確認審批通過？" @visibleChange="visibleShow(record,'0')" v-model="popconfirm1Bol"
						    ok-text="確定" cancel-text="取消"  @confirm="shTgEvent(record,'0')" :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
						    <a-icon slot="icon" type="question-circle-o" style="display: none;" />
							<a-button class="tableBzViewBtn" style="background-color: rgb(12, 139, 151);">{{record.shKhadmin1Bol ? '已處理' :'審核通過'}}</a-button>
						</a-popconfirm>
						
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
	import viewfroms from './formviews.vue'
	export default {
		components: {
			viewfroms
		},
		props: ['record', 'forms', 'ifQt'],
		data() {
			return {
				popconfirm1Bol: false,
				popconfirm2Bol: false,
				popconfirm3Bol: false,
				ishand: false,
				ifClickBtn: false,
				visible: true,
				rules: {
					domainname_address: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					register_date: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
				},
				tableData: [],
				form: {
					state:'',
				},
				aduit: false,
			}
		},
		mounted() {
			this.getdata()
		},
		methods: {
			confirmCheck(){
			    let _this = this;
			    _this.ifClickBtn = true;
			},
			getdata(record = this.record){
			    let _this = this;
			    if(!record.shShowBol){
			        let json = {
			            token : _this.$store.state.token,
			        }
			        https.fetchPost(apiUrl.getAdminRemarks,{
			            admintype: _this.forms.admintype,
			            token:json.token,
			            id:record.pdfcode
			        },json).then((data) => {
			            if(Object.is(data.qmiscode,1000)){
							_this.tableData = data.remarks;
							_this.aduit = data.aduit;
			                record.remarks = data.remarks;
			                record.aduit = data.aduit;
			                this.form.state = data.state;
			                record.ishanding = data.ishanding == '1' ? true : false;
			                record.shShowBol = true;
			                record.shKhadmin1Bol = (record.ishanding && _this.forms.admintype == 'khadmin1') && !(record.schedule == 1 && record.status == 1);
			            }else{
			                App.oTool.warningT(data.qmismsg);
			            }
			        }).catch(err => {
			            console.log(err);
			        });
			    }else{
			        record.shShowBol = false;
			    }
			},
			shUnTgEvent(record) {
				if (!this.form.remark) {
						App.oTool.warningT('請填寫備註信息');
						return
				}
				let _this = this;
				let json = {
					token: _this.$store.state.token,
				}
				https.fetchPost(apiUrl.KhAdminAduit, {
					admintype: _this.forms.admintype,
					token: json.token,
					id: record.pdfcode,
					khid: record.id,
					status: '1',
					remark: this.form.remark
				}, json).then((data) => {
					if (Object.is(data.qmiscode, 1000)) {
						App.oTool.successT('操作成功');
						this.$emit('child', true);
					} else {
						App.oTool.warningT(data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			shTgEvent(record, type) {
				if (!this.form.remark) {
					if (type == 0) {
						this.form.remark = record.shKhadmin1Bol ? '已處理' :'審核通過'
					} else if (type) {
						App.oTool.warningT('請填寫備註信息');
						return
					}
				}
				this.$ajax({
					method: 'post',
					url: this.$api.KhAdminAduit,
					data: {
						admintype: this.forms.admintype,
						token: this.$store.state.token,
						remark: this.form.remark,
						status:type,
						id:record.pdfcode,
						khid:record.id,
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', true);
						this.shShowBol = false;
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			//开启
			visibleShow(record, type) {
				let _this = this;
				if(_this.ifClickBtn){
				    if(Object.is(type,'0')){
				        // if(!_this.form.remark.trim()){
				        //     _this.popconfirm2Bol = false;
				        //     App.oTool.warningT('請填寫備註信息');
				        // }else{
				            _this.popconfirm1Bol = true;
				        // }
				    }else if(Object.is(type,'1')){
				        if(!_this.form.remark.trim()){
				            _this.popconfirm2Bol = false;
				            App.oTool.warningT('請填寫備註信息');
				        }else{
				            _this.popconfirm2Bol = true;
				        }
				    }else if(Object.is(type,'2')){
				        if(!_this.form.remark.trim()){
				            _this.popconfirm3Bol = false;
				            App.oTool.warningT('請填寫備註信息');
				        }else{
				            _this.popconfirm3Bol = true;
				        }
				    }
				    _this.ifClickBtn = false;
				}
				
				
				
			},
			viewfromFn(record) {
				let state = false
				this.$store.state.roles.map(ev => {
					if (ev.role == "khadmin1") {
						state = true
					}
				})
				return record.finishflag == 1 && this.forms.admintype == "khadmin1" && state
			},
			handclose(val) {
				this.$emit('child', true);
			},
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
	#warp_sim1 .ant-modal-header,
	#warp_sim1 .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	#warp_sim1 {
		.tableBzViewBtnView {
			display: flex;
			justify-content: space-between;
			margin-left: 4%;
		}
		.tablecenter{
			margin-left: 4%;
			text-align: center;
		}

		.tableBzViewBtn {
			margin: 0 1.5rem !important;
			color: #fff;
			height: 2rem;
			padding: .5rem 2rem;
		}
		
		// .ant-btn{
			
		// }

		.ant-form-explain {
			display: none;
		}

		.ant-col-12 {
			text-align: right;
		}
		
		.ant-form-item-label {
			width: 30%;
		}

		.ant-form-item,
		.ant-form-item-control {
			width: 100%;

			.ant-calendar-picker {
				width: 100%;
			}

		}

		.ant-form-item-control-wrapper {
			width: 70%;

			.ant-form-item-control {
				width: 100%;
			}
		}

		#lastname {
			.ant-form-item-label {
				width: 15%;
			}

			.ant-form-item-control-wrapper {
				width: 85%;

				textarea {
					width: 100%;
				}
			}
		}

		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		.warp-right {
			text-align: right;
		}


		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.mydivs {
			overflow-y: auto;
			// margin-bottom: 1rem;
			padding: 1rem;
			margin-left: 4%;
			width: 96%;
			background-color: #f5f5f5;
			margin-bottom: 1rem;

			.c {
				font-size: .8rem;
				margin: .8rem 0;
				align-items:flex-start;
				display: flex;
				justify-content: space-between;
			}

			.t {
				margin: .5rem 0;
				border-bottom: 1px solid #d9d9d9;
			}
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #999999;
		}
	}
</style>
